/**
 * The single source of truth for supported UI-chrome locales (E18, §20.1).
 * `users.locale` and every localized entity's `locale` enum reuse this exact
 * union (`z.enum(LOCALES)` in `@xdocs/schemas`) — do not redeclare elsewhere.
 */
export const LOCALES = ['en', 'ro'];
export const DEFAULT_LOCALE = 'en';
export function isLocale(value) {
    return LOCALES.includes(value);
}
